import { pushDataLayer } from "./utils/data-layer-utils";

const Event = {
  SignupOpen: "accounts_signup_start",
  SignupSubmit: "accounts_signup_submit",
  SignupComplete: "accounts_signup_complete",
};

class AnalyticWrapper {
  pushData = (data: any) => {
    pushDataLayer(data);
  };
  pushSignupRequestService = (data: any) => {
    pushDataLayer({
      signup_request_service: data,
    });
  };
  pushSignupSelectedMethod = (data: any) => {
    pushDataLayer({
      signup_selected_method: data,
    });
  };
  setReferer = (referrer: any) => {
    pushDataLayer({
      referrer: referrer,
    });
  };
  sendLog = (content: any) => {
    pushDataLayer(content);
  };
  signupOpen = () => this.sendLog({ event: Event.SignupOpen });
  signupSubmit = () => this.sendLog({ event: Event.SignupSubmit });
  signupComplete = () => this.sendLog({ event: Event.SignupComplete });
}

const Analytics = new AnalyticWrapper();

export default Analytics;
